var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfobuttonicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18311 5.96362C9.18311 6.41492 8.81726 6.78076 8.36597 6.78076C7.91467 6.78076 7.54883 6.41492 7.54883 5.96362C7.54883 5.51233 7.91467 5.14648 8.36597 5.14648C8.81726 5.14648 9.18311 5.51233 9.18311 5.96362Z",
    fill: "#919397"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 7.61816V12.4131H9.08398V7.61816H7.58398Z",
    fill: "#919397"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17188 8.86035C1.17188 4.88703 4.39289 1.66602 8.36621 1.66602C12.3395 1.66602 15.5605 4.88703 15.5605 8.86035C15.5605 12.8337 12.3395 16.0547 8.36621 16.0547C4.39289 16.0547 1.17188 12.8337 1.17188 8.86035ZM8.36621 3.16602C5.22132 3.16602 2.67188 5.71546 2.67188 8.86035C2.67188 12.0052 5.22132 14.5547 8.36621 14.5547C11.5111 14.5547 14.0605 12.0052 14.0605 8.86035C14.0605 5.71546 11.5111 3.16602 8.36621 3.16602Z",
    fill: "#919397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobuttonicon);
export default __webpack_public_path__ + "static/media/infobuttonicon.5ec84e731f8a664965784446ba305c6a.svg";
export { ForwardRef as ReactComponent };